import { render, staticRenderFns } from "./AdditionalInvoiceRecipients.vue?vue&type=template&id=7c81f9a2&scoped=true"
import script from "./AdditionalInvoiceRecipients.vue?vue&type=script&lang=ts"
export * from "./AdditionalInvoiceRecipients.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalInvoiceRecipients.vue?vue&type=style&index=0&id=7c81f9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81f9a2",
  null
  
)

export default component.exports